/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserProfileDto } from './UserProfileDto';
import {
    UserProfileDtoFromJSON,
    UserProfileDtoFromJSONTyped,
    UserProfileDtoToJSON,
    UserProfileDtoToJSONTyped,
} from './UserProfileDto';
import type { TenantAccessDto } from './TenantAccessDto';
import {
    TenantAccessDtoFromJSON,
    TenantAccessDtoFromJSONTyped,
    TenantAccessDtoToJSON,
    TenantAccessDtoToJSONTyped,
} from './TenantAccessDto';

/**
 * Session creation request containing user profile and tenant access information.
 * 
 * ## Request Structure
 * - **user_profile**: User identity information (OPTIONAL - will be extracted from JWT token if not provided)
 * - **tenant_access**: List of tenants the user can access
 * - **current_tenant_id**: Optional preferred starting tenant
 * - **metadata**: Additional session metadata (user agent, IP, etc.)
 * 
 * ## Field Details
 * - **user_profile.user_id**: Unique user identifier (OPTIONAL)
 * - **user_profile.email**: User's email address (OPTIONAL - extracted from JWT if not provided)
 * - **user_profile.name**: Full display name (OPTIONAL - extracted from JWT if not provided)
 * - **user_profile.given_name/family_name**: Split name components (OPTIONAL - extracted from JWT if not provided)
 * - **user_profile.picture**: Profile picture URL (OPTIONAL)
 * - **user_profile.preferred_username**: Username for display (OPTIONAL - extracted from JWT if not provided)
 * - **tenant_access.tenant_id**: Unique tenant identifier
 * - **tenant_access.tenant_name**: Human-readable tenant name
 * - **tenant_access.tenant_slug**: URL-friendly tenant identifier
 * - **tenant_access.permissions**: List of permission strings (e.g., "cases:read")
 * - **tenant_access.is_active**: Whether tenant access is currently active
 * 
 * ## JWT Token Fallback
 * When user_profile is not provided, the system automatically extracts user information from the JWT token:
 * - Email address for domain mapping and tenant resolution
 * - Name, given_name, family_name for user profile creation
 * - preferred_username for display purposes
 * 
 * @export
 * @interface CreateSessionRequest
 */
export interface CreateSessionRequest {
    /**
     * 
     * @type {UserProfileDto}
     * @memberof CreateSessionRequest
     */
    userProfile?: UserProfileDto;
    /**
     * 
     * @type {Array<TenantAccessDto>}
     * @memberof CreateSessionRequest
     */
    tenantAccess?: Array<TenantAccessDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateSessionRequest
     */
    currentTenantId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateSessionRequest
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateSessionRequest
     * @deprecated
     */
    jwtClaims?: { [key: string]: string; };
}

/**
 * Check if a given object implements the CreateSessionRequest interface.
 */
export function instanceOfCreateSessionRequest(value: object): value is CreateSessionRequest {
    return true;
}

export function CreateSessionRequestFromJSON(json: any): CreateSessionRequest {
    return CreateSessionRequestFromJSONTyped(json, false);
}

export function CreateSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userProfile': json['user_profile'] == null ? undefined : UserProfileDtoFromJSON(json['user_profile']),
        'tenantAccess': json['tenant_access'] == null ? undefined : ((json['tenant_access'] as Array<any>).map(TenantAccessDtoFromJSON)),
        'currentTenantId': json['current_tenant_id'] == null ? undefined : json['current_tenant_id'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'jwtClaims': json['jwt_claims'] == null ? undefined : json['jwt_claims'],
    };
}

export function CreateSessionRequestToJSON(json: any): CreateSessionRequest {
    return CreateSessionRequestToJSONTyped(json, false);
}

export function CreateSessionRequestToJSONTyped(value?: CreateSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_profile': UserProfileDtoToJSON(value['userProfile']),
        'tenant_access': value['tenantAccess'] == null ? undefined : ((value['tenantAccess'] as Array<any>).map(TenantAccessDtoToJSON)),
        'current_tenant_id': value['currentTenantId'],
        'metadata': value['metadata'],
        'jwt_claims': value['jwtClaims'],
    };
}

